module.exports = __webpack_public_path__ + "img/x-input.e288886e.svg";